<template>
  <div>
      <label :for='elementId' class='col-form-label question-label'>{{question}}</label>
      <textarea class='form-control' rows='3' :value='value' :id='elementId' 
        v-bind:style="{ height: areaHeight + 'px' }"
        ref="textarea"
      >
      </textarea>
  </div>
</template>

<script>
// TODO: Very similar to QLongReadonly. Can we replace?
// ^ Is this still the case?

export default {
  props: {
    id: Number,
    question: String,
    type: String
  },
  data: function () {
    return {
      areaHeight: 108,
      style: null
    }
  },
  computed: {
    elementId() {
      return this.type + this.id;
    },
    value() {
      return this.$store.getters['editor/answer'](this.id);
    },
  },
  mounted: function(){
    this.setHeight();
  },
  methods: { 
    setHeight: function() {
      let heightOffset = 10;
      this.areaHeight = this.$refs.textarea.scrollHeight + heightOffset;
      if(this.areaHeight < 108){
        this.areaHeight = 108;
      }
   }
  }
};
</script>

<style scoped>
</style>